import EastIcon from "@mui/icons-material/East";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Box, Button, Grid, IconButton, Tab, Tabs, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import { CustomTabPanel } from "@/erp/sale";
import {
  // ESTADOS_CONTRATO_CHOICE,
  EstadosContratoChoiceEnum,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  a11yProps,
  gridSizeMdLg1,
  gridSizeMdLg12,
  gridSizeMdLg5,
  gridSizeMdLg6,
  hasAllPermissions,
  sizeTab,
  useCheckPermissions,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
  useTabsFormOnly,
} from "@/shared";
import { useFetchContratos } from "@/shared/actions/erp";
import {
  CustomAutocompleteArrString,
  FormTabsOnly,
  GeneralTable,
  SingleIconButton,
  SingleTableBoxScene,
  TabsFormBoxScene,
} from "@/shared/components/ui";
import { SAVE_CLIENTE_CONTRATO_PERMISSIONS } from "@/shared/constants/form-permissions";
import {
  AlertSeverityEnum,
  Contrato,
  ESTADOS_INFO_CONTRATO_CHOICE,
  EstadosActualizacionContratoEnum,
} from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useState } from "react";
import { ModalGenerarExcelContratos } from "../../../shared/components";
import { useColumnsClientes } from "../../../shared/hooks";
import ClientesFibraAprobados from "./ClientesFibraAprobados";
import ClientesFibraFiltersMotivos from "./ClientesFibraFiltersMotivos";
import ClientesFibraTodos from "./ClientesFibraTodos";

export type ClientesFibraMainPageProps = {};

type FormDataClientes = {
  estadoInformacionContrato: EstadosActualizacionContratoEnum;
};

const ClientesFibraMainPage: React.FC<ClientesFibraMainPageProps> = () => {
  const navigate = useNavigate();
  useCheckPermissions(PermissionsEnum.api_view_contrato);

  const setAlert = useUiStore((s) => s.setAlert);

  const clientesFibraOpticaReturnUrl = ROUTER_PATHS.clientes.fibraOpticaNav;

  ///* table ---------------------------
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  const { handleMethodChange, valueTab, setValueTab } = useTabsFormOnly({
    initialTabValue: 0,
  });

  const {
    // globalFilter,
    pagination,
    searchTerm,
    // onChangeFilter,
    setPagination,
    // cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  const [openGenerateReport, setOpenGenerateReport] = useState(false);

  ///* form ---------------------------
  const form = useForm<FormDataClientes>({
    defaultValues: {
      estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    },
  });
  const { errors } = form.formState;

  const watchedContratoInfoState = form.watch("estadoInformacionContrato");

  ///* fetch data ---------------------------
  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,

      estado_actualizacion_exclude: "REVISADO",
      ...(watchedContratoInfoState !== EstadosActualizacionContratoEnum.ALL && {
        estado_actualizacion:
          watchedContratoInfoState ==
            EstadosActualizacionContratoEnum.PENDIENTE_REVISION
            ? "ACTUALIZADO"
            : watchedContratoInfoState,
        // : watchedContratoInfoState == EstadosActualizacionContratoEnum.APROBADO ?
        //   "REVISADO"
      }),
      tipo_servicio: "FIBRA",
      preventa_estado_aceptacion: true,
      estado_contrato_in: `${EstadosContratoChoiceEnum.ACTIVO},${EstadosContratoChoiceEnum.SUSPENDIDO}`,
      ...filterObject,
    },
  });

  ///* handlers ---------------------------
  const onEdit = (original: Contrato) => {
    navigate(`${clientesFibraOpticaReturnUrl}/ver/${original.id_contrato}`);
  };

  ///* columns ---------------------------
  const { clientesFibraColumns } = useColumnsClientes();

  ///* effects ---------------------------
  useLoaders(isLoadingContratos || isRefetchingContratos);

  return (
    <SingleTableBoxScene
      title={"Clientes Fibra Óptica"}
      py={2}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs preventa"
          >
            <Tab label="TODOS LOS CONTRATOS" value={0} {...a11yProps(0)} />
            <Tab label="FILTROS" value={1} {...a11yProps(1)} />
            <Tab label="APROBADOS" value={2} {...a11yProps(2)} />
            <Tab label="BRAS" value={3} {...a11yProps(3)} />
          </Tabs>
        </Box>

      </Box>

      {/* =================== Todos los registros =================== */}
      <CustomTabPanel index={valueTab} value={0}>
        <ClientesFibraTodos/>
      </CustomTabPanel>

      {/* =================== Reporte con mas filtros =================== */}
      <CustomTabPanel index={valueTab} value={1}>
        <ClientesFibraFiltersMotivos />
      </CustomTabPanel>


      {/* =================== Reporte Clientes Aprobados =================== */}
      <CustomTabPanel index={valueTab} value={2}>
        <ClientesFibraAprobados />
      </CustomTabPanel>


      {/* =================== BRAS =================== */}
      <CustomTabPanel index={valueTab} value={3}>
        <ClientesFibraTodos filterParams={{bras_isnull:false, estado_actualizacion_exclude: undefined}}/>
      </CustomTabPanel>

      
    </SingleTableBoxScene>
  )
  return (
    <>
      <TabsFormBoxScene
        titlePage="Clientes Fibra Óptica" // only for typescript
        // titlePageNode={<ClienteFibraFormTitle contract={contract!} showRejectButton={true} />}
        // size={gridSizeMdLg10} // actual form container size
        showBtns={false}
        // // custom btns
        size={gridSizeMdLg12}
        showCustomBtns
        pb={0}
        // // tabs
        tabs={
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="TODOS LOS CONTRATOS" value={1} {...a11yProps(1)} />
            <Tab label="FILTROS" value={2} {...a11yProps(2)} />
            <Tab label="APROBADOS" value={3} {...a11yProps(3)} />
          </FormTabsOnly>
        }
      >
        {/* =================== Todos los registros =================== */}
        <CustomTabPanel index={valueTab} value={1}>
          <Grid item container {...gridSizeMdLg12}>
            <Grid
              container
              spacing={1}
              {...gridSizeMdLg12}
              sx={{ marginBottom: 4 }}
            >
              {/* <Grid item> */}
              <CustomAutocompleteArrString
                size={gridSizeMdLg6}
                label="Estado Contrato"
                name="estadoInformacionContrato"
                control={form.control}
                defaultValue={
                  form.getValues().estadoInformacionContrato ||
                  EstadosActualizacionContratoEnum.ALL
                }
                options={ESTADOS_INFO_CONTRATO_CHOICE}
                isLoadingData={false}
                error={errors.estadoInformacionContrato}
                helperText={errors.estadoInformacionContrato?.message}
                // size={gridSizeMdLg12}
                disableClearable
              />
              <Grid item>
                <SingleIconButton
                  size={gridSizeMdLg1}
                  startIcon={<FilterAltOffIcon />}
                  onClick={() => {
                    form.setValue(
                      "estadoInformacionContrato",
                      EstadosActualizacionContratoEnum.ALL
                    );
                  }}
                />
              </Grid>
              <Grid
                item
                container
                {...gridSizeMdLg5}
                alignContent={"center"}
                justifyItems={"center"}
                justifyContent={"end"}
              >
                <Button
                  onClick={() => setOpenGenerateReport(true)}
                  variant="outlined"
                  sx={{
                    py: 1,
                    my: 0,
                    marginX: 1,
                  }}
                  size="small"
                >
                  Generar Reporte por Fechas
                </Button>
              </Grid>
            </Grid>
            <GeneralTable<Contrato>
              columns={clientesFibraColumns}
              data={contratosPagingRes?.data?.data || []}
              //
              isLoading={isLoadingContratos}
              isRefetching={isRefetchingContratos}
              // // filters - server side
              enableManualFiltering={true}
              columnFilters={columnFilters}
              onColumnFiltersChange={setColumnFilters}
              // // search
              enableGlobalFilter={false}
              // // pagination
              pagination={pagination}
              onPaging={setPagination}
              rowCount={contratosPagingRes?.data?.count}
              // // actions ========
              enableColumnActions={hasAllPermissions([
                ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
              ])}
              enableEditing={hasAllPermissions([
                ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
              ])}
              actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
              // crud
              canEdit={hasAllPermissions([
                ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
              ])}
              // onEdit={onEdit}
              onCustomEdit={(r) =>
                r.estado_contrato == EstadosContratoChoiceEnum.CANCELADO ? (
                  ""
                ) : (
                  <Tooltip title={"Ir a detalle"} placement="top">
                    <IconButton
                      onClick={() => {
                        if (
                          !hasAllPermissions([
                            PermissionsEnum.api_change_contrato,
                            PermissionsEnum.api_add_contrato,
                          ])
                        )
                          return setAlert(
                            true,
                            "Acceso denegado. No cumples con los permisos necesarios: [403]",
                            AlertSeverityEnum.error
                          );

                        onEdit(r!);
                      }}
                    >
                      <EastIcon />
                    </IconButton>
                  </Tooltip>
                )
              }
              // editIcon={<EastIcon />}
              toolTipTitleEditIcon="Ir a detalle"
              canDelete={false}
            />
          </Grid>
        </CustomTabPanel>

        {/* =================== Reporte con mas filtros =================== */}
        <CustomTabPanel index={valueTab} value={2}>
          <ClientesFibraFiltersMotivos />
        </CustomTabPanel>

        {/* =================== Reporte Clientes Aprobados =================== */}
        <CustomTabPanel index={valueTab} value={3}>
          <ClientesFibraAprobados />
        </CustomTabPanel>
      </TabsFormBoxScene>

      {openGenerateReport ? (
        <ModalGenerarExcelContratos
          open={openGenerateReport}
          setOpen={setOpenGenerateReport}
        />
      ) : null}
    </>
  );
};

export default ClientesFibraMainPage;
